var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLowExpense = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003865",
    fillRule: "evenodd",
    d: "M8.66 2a.5.5 0 0 1 .294.095l.06.051 3.06 3.06 5.277 5.268c.7.697.743 1.701.125 2.428l-.116.126-5.249 5.25a.5.5 0 0 1-.638.057l-.069-.057-8.656-8.652a2.557 2.557 0 0 1-.74-1.606L2 7.818V2.5a.5.5 0 0 1 .41-.492L2.5 2h6.16Zm-.208 1H3v4.818c0 .31.092.61.261.864l.091.122.103.115 8.302 8.297 4.898-4.897c.314-.313.339-.714.071-1.048l-.08-.089L8.452 3ZM10.5 7v1h1v1h-2c-.3 0-.5.2-.5.5 0 .267.158.454.404.493L9.5 10h1.003c.85.005 1.497.663 1.497 1.5a1.49 1.49 0 0 1-1.353 1.493L10.5 13v1h-1v-1h-1v-1h1.998a.491.491 0 0 0 .502-.5.478.478 0 0 0-.405-.492L10.5 11h-1A1.47 1.47 0 0 1 8 9.5c0-.803.574-1.423 1.352-1.493L9.5 8V7h1ZM6.25 4.201a1.5 1.5 0 1 1-1.5 2.598 1.5 1.5 0 0 1 1.5-2.598Zm-.92.829-.08.037-.072.05a.5.5 0 1 0 .152-.087Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLowExpense);
export default ForwardRef;